import { DEV_TRANSLATE_LANG } from '@core/services/app-translate-language.service';
import { environment } from '@env/environment';

export interface AppLanguage {
  labelKey: string;
  value: string;
  flag: string;
  emoji: string;
  dir: 'ltr' | 'rtl';
}

const BASE_LANGUAGES: AppLanguage[] = [
  { labelKey: 'lang_tr', value: 'tr', flag: 'assets/flags/TR.png', emoji: '🇹🇷', dir: 'ltr' },
  { labelKey: 'lang_en', value: 'en', flag: 'assets/flags/EN.png', emoji: '🇺🇸', dir: 'ltr' },
  { labelKey: 'lang_az', value: 'az', flag: 'assets/flags/AZ.png', emoji: '🇦🇿', dir: 'ltr' },
  { labelKey: 'lang_ru', value: 'ru', flag: 'assets/flags/RU.png', emoji: '🇷🇺', dir: 'ltr' },
  { labelKey: 'lang_ar', value: 'ar', flag: 'assets/flags/AR.png', emoji: '🇸🇦', dir: 'rtl' },
];

const DEV_LANGUAGE: AppLanguage = {
  labelKey: 'Dev',
  value: DEV_TRANSLATE_LANG,
  flag: 'favicon.png',
  emoji: '🛠',
  dir: 'ltr',
};

/** Single source of truth for UI language pickers (header, config bar, auth). */
export const APP_LANGUAGES: AppLanguage[] = [
  ...BASE_LANGUAGES,
  ...(!environment.production ? [DEV_LANGUAGE] : []),
];

export const RTL_LANGUAGES = new Set(
  APP_LANGUAGES.filter((lang) => lang.dir === 'rtl').map((lang) => lang.value)
);

export function isRtlLanguage(lang: string): boolean {
  return RTL_LANGUAGES.has(lang);
}
